import { useState ,useEffect,} from "react";
import { useVendor } from "./Hooks/useVendor";
import { useNavigate, useParams, useLocation, } from "react-router-dom";
import { Spinner, GenericTable, ProductCategoryFilter, Pagination, } from "../../Components/Common";
import { VENDOR_MATERIAL_COLUMNS, VENDOR_MATERIAL_LABELS} from "./constants";
import { ArrowLeft, Trash2,} from "lucide-react";
import { VENDOR_MODES } from "./constants";
import { VIEW, EDIT, VENDOR_MASTER, } from "../../routes";

const VendorActions = () => {
    const param = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [mode, setMode] = useState(VENDOR_MODES.VIEW);
    const {
        loading,
        page,
        totalPages,
        rowsPerPage,
        onPageChange,
        onPageSizeChange,
        fetchVendorById,
        newVendor,
        updateVendorDetails,
        fetchVendorProduct,
        addVendorProducts,
        deleteVendorProducts,
    } = useVendor();

    const [vendor, setVendor] = useState({
        name: "",
        contact_person_name: "",
        mobile: "",
        address: "",
        gst_details: "",
        bank_name: "",
        branch_name: "",
        account_name: "",
        account_number: "",
        ifsc_code: "",
        pan_no: "",
        tan_no: "",
    });
    const [vendorProducts, setVendorProducts] = useState([]);

    const fetchVendorProducts = async () => {
        if (!param.instanceId) return;
        const data = await fetchVendorProduct(param.instanceId);
        setVendorProducts(data || []); 
    };

    const fetchVendorDetails = async (instanceId) => {
        const VendorData = await fetchVendorById(instanceId);
        if (VendorData) {
            setVendor(VendorData);
        }
    };

    // Handle input change for create/edit form
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setVendor((prev) => ({ ...prev, [name]: value }));
    };

    const handleVendorProduct = (product) => {
        // Add the new product
        const newProductId = product.id ;
        // Check if the product already exists in vendorProducts
        if (
            vendorProducts.some((m) => {
                const existingId = m.product?.id || m.product_id;
                return existingId === newProductId;
            })
        ) return;
        setVendorProducts((prev) => [
            ...prev,
            {
                id: null, // VendorProduct.id will be null until backend creates it
                product_id:product.id,
                product_name: product.product_name,
                category_name: product.category_name,
                UOM: product.UOM_name,
                specification: product.specification,
                isNew: true,
            },
        ]);
    };

    const removeMaterial = async (material) => {
        if (mode === VENDOR_MODES.EDIT && !material.isNew) {
            await deleteVendorProducts(param.instanceId, material.id);
        }
        setVendorProducts((prev) =>
            prev.filter((m) => {
                if (material.isNew) {
                    return m.product_id !== material.product_id;
                } else {
                    return m.id !== material.id;
                }
            })
        );
    };

    // Save vendor
    const handleSaveVendor = async () => {

        let vendorId = param.instanceId;

            if (mode === VENDOR_MODES.CREATE) {
                const response = await newVendor(vendor);
                vendorId = response?.id || response?.data?.id;
            } else {
                await updateVendorDetails(param.instanceId, vendor);
            }

            // Only add newly selected products
        const newProducts = vendorProducts
            .filter((p) => p.isNew)
            .map((p) => p.product_id); // array of product IDs

        if (newProducts.length) {
            await addVendorProducts(vendorId, { products: newProducts });
        }
        navigate(VENDOR_MASTER);
    };

    const renderVendorDetails = () => {
        return loading ? (
            <div className="flex justify-center items-center h-[30vh]">
                <Spinner />
            </div>
        ) : (
            <div className="grid grid-cols-2 gap-x-6 gap-y-3">
                    <div>
                        <p className={`text-sm ${mode !== VENDOR_MODES.VIEW ? "font-bold text-gray-700 " : "font-normal text-gray-500 "
                            }`}>Vendor Name
                            {mode !== VENDOR_MODES.VIEW && (
                            <sub className="text-red-500 top-0"> *</sub>
                            )}
                        </p>
                        {mode === VENDOR_MODES.VIEW ? (
                            <p className="font-semibold text-gray-800 mt-0.5">
                                {vendor?.name || "-"}
                            </p>
                        ) : (
                            <input
                                type="text"
                                name="name"
                                value={vendor.name || ""}
                                onChange={handleInputChange}
                                    className="border border-gray-300 rounded-lg px-3 py-1 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                placeholder="Enter Vendor Name"
                            />
                        )}
                    </div>
                    <div>
                        <p className={`text-sm ${mode !== VENDOR_MODES.VIEW ? "font-bold text-gray-700 " : "font-normal text-gray-500 "
                            }`}>Contact Person Name
                            {mode !== VENDOR_MODES.VIEW && (
                            <sub className="text-red-500 top-0"> *</sub>
                            )}
                        </p>
                        {mode === VENDOR_MODES.VIEW ? (
                            <p className="font-semibold text-gray-800 mt-0.5">
                                {vendor?.contact_person_name || "-"}
                            </p>
                        ) : (
                            <input
                                type="text"
                                name="contact_person_name"
                                value={vendor.contact_person_name || ""}
                                onChange={handleInputChange}
                                    className="border border-gray-300 rounded-lg px-3 py-1 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                placeholder="Enter Contact Person Name"
                            />
                        )}
                    </div>
                    <div>
                        <p className={`text-sm  ${mode !== VENDOR_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                            }`}>Mobile No
                            {mode !== VENDOR_MODES.VIEW && (
                            <sub className="text-red-500 top-0"> *</sub>
                            )}
                        </p>
                        {mode === VENDOR_MODES.VIEW ? (
                            <p className="font-semibold text-gray-800 mt-0.5">
                                {vendor?.mobile || "-"}
                            </p>
                        ) : (
                            <input
                                type="text"
                                name="mobile"
                                value={vendor.mobile || ""}
                                onChange={handleInputChange}
                                    className="border border-gray-300 rounded-lg px-3 py-1 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                placeholder="Enter Mobile Number"
                                maxLength={10}
                            />
                        )}
                    </div>
                    <div>
                        <p className={`text-sm ${mode !== VENDOR_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                                }`} >GSTIN
                            {mode !== VENDOR_MODES.VIEW && (
                            <sub className="text-red-500 top-0"> *</sub>
                            )}
                        </p>
                        {mode === VENDOR_MODES.VIEW ? (
                            <p className="font-semibold text-gray-800 mt-0.5">
                                {vendor?.gst_details || "-"}
                            </p>
                        ) : (
                            <input
                                type="text"
                                name="gst_details"
                                value={vendor.gst_details || ""}
                                onChange={handleInputChange}
                                    className="border border-gray-300 rounded-lg px-3 py-1 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                placeholder="Enter GST Details"
                            />
                        )}
                    </div>
                    <div>
                        <p className={`text-sm ${mode !== VENDOR_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                            }`} >Bank Name
                            {mode !== VENDOR_MODES.VIEW && (
                                <sub className="text-red-500 top-0"> *</sub>
                            )}
                        </p>
                        {mode === VENDOR_MODES.VIEW ? (
                            <p className="font-semibold text-gray-800 mt-0.5">
                                {vendor?.bank_name || "-"}
                            </p>
                        ) : (
                            <input
                                type="text"
                                name="bank_name"
                                value={vendor.bank_name || ""}
                                onChange={handleInputChange}
                                className="border border-gray-300 rounded-lg px-3 py-1 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                placeholder="Enter Bank Name"
                            />
                        )}
                    </div>
                    <div>
                        <p className={`text-sm ${mode !== VENDOR_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                            }`} >Branch
                            {mode !== VENDOR_MODES.VIEW && (
                                <sub className="text-red-500 top-0"> *</sub>
                            )}
                        </p>
                        {mode === VENDOR_MODES.VIEW ? (
                            <p className="font-semibold text-gray-800 mt-0.5">
                                {vendor?.branch_name || "-"}
                            </p>
                        ) : (
                            <input
                                type="text"
                                name="branch_name"
                                value={vendor.branch_name || ""}
                                onChange={handleInputChange}
                                className="border border-gray-300 rounded-lg px-3 py-1 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                placeholder="Enter Branch Name"
                            />
                        )}
                    </div>
                    <div>
                        <p className={`text-sm ${mode !== VENDOR_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                            }`} >Account Holder
                            {mode !== VENDOR_MODES.VIEW && (
                                <sub className="text-red-500 top-0"> *</sub>
                            )}
                        </p>
                        {mode === VENDOR_MODES.VIEW ? (
                            <p className="font-semibold text-gray-800 mt-0.5">
                                {vendor?.account_name || "-"}
                            </p>
                        ) : (
                            <input
                                type="text"
                                name="account_name"
                                value={vendor.account_name || ""}
                                onChange={handleInputChange}
                                className="border border-gray-300 rounded-lg px-3 py-1 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                placeholder="Enter Account Holder Name"
                            />
                        )}
                    </div>
                    <div>
                        <p className={`text-sm ${mode !== VENDOR_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                            }`} >Account Number
                            {mode !== VENDOR_MODES.VIEW && (
                                <sub className="text-red-500 top-0"> *</sub>
                            )}
                        </p>
                        {mode === VENDOR_MODES.VIEW ? (
                            <p className="font-semibold text-gray-800 mt-0.5">
                                {vendor?.account_number || "-"}
                            </p>
                        ) : (
                            <input
                                type="text"
                                name="account_number"
                                value={vendor.account_number || ""}
                                onChange={handleInputChange}
                                className="border border-gray-300 rounded-lg px-3 py-1 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                placeholder="Enter Account Number"
                            />
                        )}
                    </div>
                    <div>
                        <p className={`text-sm ${mode !== VENDOR_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                            }`} >IFSC Code 
                            {mode !== VENDOR_MODES.VIEW && (
                                <sub className="text-red-500 top-0"> *</sub>
                            )}
                        </p>
                        {mode === VENDOR_MODES.VIEW ? (
                            <p className="font-semibold text-gray-800 mt-0.5">
                                {vendor?.ifsc_code || "-"}
                            </p>
                        ) : (
                            <input
                                type="text"
                                name="ifsc_code"
                                value={vendor.ifsc_code || ""}
                                onChange={handleInputChange}
                                className="border border-gray-300 rounded-lg px-3 py-1 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                placeholder="Enter IFSC Code"
                            />
                        )}
                    </div>
                    <div>
                        <p className={`text-sm ${mode !== VENDOR_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                            }`} >PAN Number
                            {mode !== VENDOR_MODES.VIEW && (
                                <sub className="text-red-500 top-0"> *</sub>
                            )}
                        </p>
                        {mode === VENDOR_MODES.VIEW ? (
                            <p className="font-semibold text-gray-800 mt-0.5">
                                {vendor?.pan_no || "-"}
                            </p>
                        ) : (
                            <input
                                type="text"
                                name="pan_no"
                                value={vendor.pan_no || ""}
                                onChange={handleInputChange}
                                className="border border-gray-300 rounded-lg px-3 py-1 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                placeholder="Enter PAN Number"
                            />
                        )}
                    </div>
                    <div>
                        <p className={`text-sm ${mode !== VENDOR_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                            }`} >TAN Number
                            {mode !== VENDOR_MODES.VIEW && (
                                <sub className="text-red-500 top-0"> *</sub>
                            )}
                        </p>
                        {mode === VENDOR_MODES.VIEW ? (
                            <p className="font-semibold text-gray-800 mt-0.5">
                                {vendor?.tan_no || "-"}
                            </p>
                        ) : (
                            <input
                                type="text"
                                name="tan_no"
                                value={vendor.tan_no || ""}
                                onChange={handleInputChange}
                                className="border border-gray-300 rounded-lg px-3 py-1 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                placeholder="Enter TAN Number"
                            />
                        )}
                    </div>
                    <div className="col-span-2">
                        <p
                            className={`text-sm  ${mode !== VENDOR_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                                }`} >Address
                            {mode !== VENDOR_MODES.VIEW && (
                            <sub className="text-red-500 top-0"> *</sub>
                            )}
                        </p>
                        {mode === VENDOR_MODES.VIEW ? (
                            <p className="font-semibold text-gray-800 mt-0.5">
                                {vendor?.address || "-"}
                            </p>
                        ) : (
                            <textarea
                                name="address"
                                value={vendor.address || ""}
                                onChange={handleInputChange}
                                className="w-full border border-gray-300 rounded-lg px-3 py-1 focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                placeholder="Enter Address"
                                rows={3}
                            />
                        )}
                    </div>
            </div>
        );
    };

    const renderFields = (key, row) => {
        switch (key) {
            case "product_name":
                return row.product?.product_name || row.product_name || "-";

            case "category_name":
                return row.product?.category_name || row.category_name || "-";

            case "UOM":
                return row.product?.UOM_name || row.UOM || "-";

            case "specification":
                return row.product?.specification || row.specification || "-";

            case "action":
                return (
                    <button
                        onClick={() => removeMaterial(row)}
                        className={`text-red-500 hover:text-red-700 ${mode !== VENDOR_MODES.EDIT ? "opacity-50 cursor-not-allowed" : ""
                            }`}
                        disabled={mode !== VENDOR_MODES.EDIT}
                    >
                        <Trash2 size={18} />
                    </button>
                );

            default:
                return row[key] || "-";
        }
    };

    useEffect(() => {
        fetchVendorProducts();
    }, [param.instanceId, page, rowsPerPage]);

    useEffect(() => {
        if (location.pathname.includes(EDIT) && param.instanceId) {
            setMode(VENDOR_MODES.EDIT);
            fetchVendorDetails(param.instanceId);
        }
        else if (location.pathname.includes(VIEW) && param.instanceId) {
            setMode(VENDOR_MODES.VIEW);
            fetchVendorDetails(param.instanceId);
        }
        else {
            setMode(VENDOR_MODES.CREATE);
        }
    }, [param.instanceId, location.pathname]);

    return (
        <div className="px-4 py-4 overflow-y-hidden max-h-full">
            <div className="mb-4 mt-1">
                <span
                    onClick={() => navigate(VENDOR_MASTER)}
                    className="inline-flex items-center text-blue-600 hover:text-blue-800 cursor-pointer gap-1"
                >
                    <ArrowLeft size={20} />
                    <h1 className="text-xl text-secondary font-semibold">
                        {mode === VENDOR_MODES.CREATE
                            ? "Create Vendor"
                            : mode === VENDOR_MODES.EDIT
                                ? "Edit Vendor"
                                : "Vendor Details"}
                    </h1>
                </span>
            </div>
            {/* Two Column Layout */}
            <div className="grid grid-cols-1 lg:grid-cols-[40%_60%] gap-2">
                {/* Left Column - Basic Details */}
                <div className="pr-4 border-r border-gray-400 h-[70vh] overflow-y-scroll">
                    <h3 className="text-lg font-semibold text-primary mb-4 flex items-center gap-2 mt-2">
                        <span className="inline-block w-1.5 h-6 bg-primary rounded-full"></span>
                       Basic Details
                    </h3>
                    {renderVendorDetails()}
                </div>
                {/* Right Column - Material Preference */}
                <div className="flex flex-col h-full">
                    <h3 className="text-lg font-semibold text-primary mb-4 flex items-center gap-2 mt-2">
                        <span className="inline-block w-1.5 h-6 bg-primary rounded-full"></span>
                        Material Preference
                    </h3>
                    {mode !== VENDOR_MODES.VIEW && (
                        <div className="mb-4 mt-2">
                             <ProductCategoryFilter
                                onProductSelect={handleVendorProduct}
                            />
                        </div>)}
                    {loading ? (
                        <div className="flex justify-center items-center h-[30vh]">
                            <Spinner />
                        </div>
                    ) : (
                        <div>
                            {/* Desktop View */}
                                <div className={`md:block overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 
        ${mode === VENDOR_MODES.VIEW ? "h-[60vh]" : "h-[35vh]"}`}
                                >
                                <GenericTable
                                    tableColumns={VENDOR_MATERIAL_COLUMNS}
                                    tableRows={vendorProducts}
                                    columnLabels={VENDOR_MATERIAL_LABELS}
                                    renderField={renderFields}
                                    enableMobileCardView={false}
                                />
                                </div>
                                {mode !== VENDOR_MODES.VIEW && (
                                    <div className="flex justify-end gap-2 border-gray-200 mt-1">
                                        <button
                                            onClick={handleSaveVendor}
                                            className="px-6 py-2 bg-primary text-white flex justify-center shadow hover:shadow-lg hover:bg-secondary active:scale-95 transition-all text-sm font-medium mr-6 mt-3"
                                        >
                                            {mode === VENDOR_MODES.CREATE ? "Create" : "Update"}
                                        </button>
                                    </div>
                                )}
                            {/* Pagination */}
                            <div className="mt-auto pt-2">
                                <Pagination
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    totalPages={totalPages}
                                    onPageChange={onPageChange}
                                    onPageSizeChange={onPageSizeChange}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

    );
};

export default VendorActions;
